import { useContext } from 'react';
import ConfigContext from '../configProvider/ConfigContext';

export default () => useContext(ConfigContext);
